<template>
  <div class="profile">
    <el-tabs class="el-tabs-common" v-model="current">
      <el-tab-pane
        v-for="(item, index) in types"
        :key="index"
        :name="item.type"
        :label="item.label"
      ></el-tab-pane>
    </el-tabs>
    <div v-show="current == '1'">
      <el-form
        :model="userInfo"
        :rules="rules"
        ref="userForm"
        label-width="100px"
      >
        <el-form-item label="当前头像" prop="avatar">
          <img class="avatar" :src="userInfo.avatar" />
          <el-upload
            :action="uploadUrl"
            :show-file-list="false"
            list-type="picture"
            :before-upload="onBeforeUpload"
            :on-success="uploadSuccess"
            :headers="headers"
            accept="image/jpeg, image/jpg, image/png"
            style="display: inline-block"
          >
            <a class>修改</a>
          </el-upload>
        </el-form-item>
        <el-form-item label="姓名" prop="nickname">
          <el-input v-model="userInfo.nickname" style="width: 220px"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <span>{{ userInfo.mobile }}</span>
          <span class="change_mobile" @click="changeMobile()">更换手机号</span>
        </el-form-item>
        <el-form-item
          v-if="
            $store.state.commonSetting.switch_offline_attend_mode == 2 ||
            $store.state.commonSetting.switch_offline_attend_mode == 3
          "
          label="人脸识别照片"
          prop="face_photo"
        >
          <div class="face-photo_wrap">
            <el-upload
              ref="uploadFace"
              v-show="!userInfo.face_photo"
              class="face-photo"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              accept="image/gif, image/jpeg, image/jpg, image/png"
              :before-upload="onFacePhotoBeforeUpload"
              :on-success="uploadFaceSuccess"
            >
              <i class="el-icon-plus"></i>
              <div class="text">上传照片</div>
            </el-upload>
            <template v-if="userInfo.face_photo">
              <img class="face-photo_img" :src="userInfo.face_photo" />
              <a
                class="face-photo_modify"
                @click="
                  $refs.uploadFace.$el.querySelector('.el-upload').click()
                "
              >
                修改
              </a>
            </template>
          </div>
          <div class="face-photo_tip">
            注：上传照片将用于人脸识别系统线下考勤，请上传本人清晰正脸照片，否则会导致上课打卡失败
          </div>
        </el-form-item>
        <el-form-item
          label="所属校区"
          prop="origin_school_name"
          v-if="schoolCount > 1"
        >
          <span>{{ userInfo.origin_school_name }}</span>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="userInfo.sex">
            <el-radio label="0">男</el-radio>
            <el-radio label="1">女</el-radio>
            <el-radio label="3">保密</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="出生日期" prop="birthday">
          <el-date-picker
            v-model="userInfo.birthday"
            type="date"
            placeholder="选择出生日期"
            :picker-options="options"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所在城市" prop="district_id">
          <AreaSelect
            :provinceId="userInfo.province_id"
            :cityId="userInfo.city_id"
            :districtId="userInfo.district_id"
            @change="areaChange"
          ></AreaSelect>
        </el-form-item>

        <el-form-item
          label="报考院校"
          prop="nickname"
        >
          <el-input
            v-model="userInfo.apply_colleges"
            style="width: 430px"
          ></el-input>
        </el-form-item>


        <el-form-item
          label="报考专业"
          prop="sex"
        >
          <!-- <el-select v-model="userInfo.apply_major" filterable style="width: 260px">
            <el-option :key="index" v-for="(item,index) in columns" :value="item" :label="item"></el-option>
          </el-select> -->
          <el-input
            v-model="userInfo.apply_major"
            style="width: 430px"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item
          v-for="(attr, index) in attrs"
          :label="attr.attr"
          :key="attr.id"
          :prop="'attr' + index"
        >
          <el-select
            v-model="userInfo['attr' + index]"
            v-if="attr.type == 1"
            filterable
            style="width: 260px"
          >
            <el-option
              v-for="item in attr.value"
              :value="item.id"
              :key="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
          <el-checkbox-group
            v-model="userInfo['attr' + index]"
            v-if="attr.type == 2"
          >
            <el-checkbox
              v-for="item in attr.value"
              :key="item.id"
              :label="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
          <el-input
            v-model="userInfo['attr' + index]"
            style="width: 470px"
            v-if="attr.type == 3"
          ></el-input>
          <el-input
            v-model="userInfo['attr' + index]"
            style="width: 470px"
            v-if="attr.type == 6"
          ></el-input>
          <el-input
            type="textarea"
            resize="none"
            placeholder="请输入"
            v-model="userInfo['attr' + index]"
            v-if="attr.type == 4"
          ></el-input>
          <template v-if="attr.type == 5">
            <AreaSelect
              class="area-select"
              :provinceId="userInfo['attr' + index + 'province_id']"
              :cityId="userInfo['attr' + index + 'city_id']"
              :districtId="userInfo['attr' + index]"
              :index="index"
              @change="areaChangeMore"
            ></AreaSelect>
            <el-input
              v-model="userInfo['attr' + index + 'address']"
              style="width: 470px; display: block; margin-top: 10px"
            ></el-input>
          </template>
          <el-date-picker
            v-model="userInfo['attr' + index]"
            type="date"
            placeholder="请选择"
            v-if="attr.type == 7"
            style="width: 260px"
          ></el-date-picker>
          <el-date-picker
            v-model="userInfo['attr' + index]"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            v-if="attr.type == 8"
          ></el-date-picker>
          <template v-if="attr.type == 9">
            <el-upload
              class="el-upload--picture-card"
              @click.native="currentClickIndex(index)"
              :action="uploadUrl"
              :show-file-list="false"
              list-type="picture"
              :on-success="uploadSuccessSingle"
              :headers="headers"
              accept="image/gif, image/jpeg, image/jpg, image/png"
            >
              <img
                v-if="userInfo['attr' + index]"
                class="single"
                :src="userInfo['attr' + index]"
              />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
          </template>
          <el-upload
            ref="upload"
            :action="uploadUrl"
            list-type="picture-card"
            :file-list="attr.fileList"
            :headers="headers"
            :limit="9"
            :multiple="true"
            :on-success="uploadSuccessMore"
            :on-remove="handleRemove"
            :on-exceed="uploadExceed"
            accept="image/gif, image/jpeg, image/jpg, image/png"
            v-if="attr.type == 10"
          >
            <i @click="currentClickIndex(index)" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="saveUser">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-show="current == '2'">
      <el-form label-width="112px">
        <el-form-item label="密码设置" class="reset-pass">
          <div class="box">
            <el-input
              value="******"
              readonly
              style="width: 180px; margin-left: 20px"
            ></el-input>
            <el-button type="primary" @click="showPasswordDialog = true">
              修改密码
            </el-button>
          </div>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="showPasswordDialog=true">修改密码</el-button>
        </el-form-item> -->
      </el-form>
      <el-dialog
        title="修改密码"
        :center="true"
        :visible.sync="showPasswordDialog"
        width="515px"
        class="reset-pass-dialog"
      >
        <el-form
          :model="passwordForm"
          :rules="passwordRules"
          ref="passwordForm"
          label-width="100px"
        >
          <!-- <el-form-item label="手机号" prop="mobile" class="reset-pass-mobile">
            <div class="box">
              <el-input v-model="passwordForm.mobile" placeholder="请输入手机号">
              </el-input>
              <a class="reset-code" @click="getSmsCode" v-if="countDown==0" style="cursor:default;">获取验证码</a>
              <span v-else>{{countDown}}秒后重新发送</span>
            </div>
          </el-form-item> -->
          <p class="mobile">
            当前绑定的手机号：
            <span>{{ hideMobile }}</span>
          </p>
          <el-form-item
            label="验证码"
            prop="sms_code"
            class="reset-pass-mobile"
          >
            <div class="box">
              <el-input
                v-model="passwordForm.sms_code"
                placeholder="请输入验证码"
              ></el-input>
              <a
                class="reset-code"
                @click="getSmsCode"
                v-if="countDown == 0"
                style="cursor: default"
              >
                获取验证码
              </a>
              <span class="reset-code" v-else>{{ countDown }}秒后重新发送</span>
            </div>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input
              v-model="passwordForm.password"
              placeholder="请输入新密码"
              type="password"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitChangePassword">
            确 定
          </el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改手机号 -->
    <el-dialog
      :title="changePhoneStep == 1 ? '安全认证' : '绑定新手机号'"
      center
      :visible.sync="showPhoneDialog"
      :show-close="false"
      width="480px"
      class="reset-phone-dialog"
    >
      <div v-if="changePhoneStep == 1">
        <p class="tips">为确保是你本人操作，请完成以下验证</p>
        <p class="tips phone-tips">我们已经发送了验证码到你的手机：</p>
        <p class="tips phone-tips phone">+86 {{ userInfo.mobile }}</p>
      </div>
      <el-form
        :model="phoneForm"
        :rules="phoneRules"
        ref="phoneForm"
        label-width="0"
      >
        <!-- 第一步：验证旧手机 -->
        <el-form-item label="" prop="old_sms_code" v-if="changePhoneStep == 1">
          <el-input
            style="width: 310px"
            v-model="phoneForm.old_sms_code"
            placeholder="请输入验证码"
          ></el-input>
          <a
            class="reset-code active"
            @click="getOldSmsCode"
            v-if="phoneCountDown == 0"
          >
            获取验证码
          </a>
          <span v-else class="reset-code" style="cursor: default">
            重新获取{{ phoneCountDown }}
          </span>
        </el-form-item>
        <!-- 第二步：绑定手机号 -->
        <el-form-item label="" prop="mobile" v-if="changePhoneStep == 2">
          <div class="box">
            <el-input
              v-model="phoneForm.mobile"
              placeholder="请输入新手机号码"
              maxlength="11"
            >
              <template slot="prepend">+86</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="" prop="sms_code" v-if="changePhoneStep == 2">
          <el-input
            style="width: 310px"
            v-model="phoneForm.sms_code"
            placeholder="请输入验证码"
          ></el-input>
          <a
            class="reset-code active"
            @click="getNewSmsCode"
            v-if="newPhoneCountDown == 0"
          >
            获取验证码
          </a>
          <span v-else class="reset-code" style="cursor: default">
            重新获取{{ newPhoneCountDown }}
          </span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog()">取消</el-button>
        <el-button
          type="primary"
          @click="submitChangePhone()"
          v-if="changePhoneStep == 1"
        >
          下一步
        </el-button>
        <el-button
          type="primary"
          :class="!phoneForm.mobile || !phoneForm.sms_code ? 'disabled' : ''"
          @click="submitNewPhone()"
          v-else
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import AreaSelect from "@/components/AreaSelect.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";
const buildConfig = require("@/build/" + process.env.BUILD_ENV + ".js");
import { Encrypt } from "@/utils/encryption.js";
export default {
  name: "MemberProfile",
  components: {
    AreaSelect,
  },
  data() {
    let validateRePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (this.$pub.guarantee(1, value)) {
        if (this.$pub.guarantee(1, value) == true) {
          callback();
        } else {
          callback(new Error(this.$pub.guarantee(1, value)));
        }
      } else {
        callback();
      }
    };
    let validatePhone = (rule, value, callback) => {
      let reg = /^1\d{10}$/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (value.length < 11) {
        callback(new Error("手机号码不足11位，请重新输入！"));
      } else if (reg.test(value) === false) {
        callback(new Error("请输入正确的11位号码！"));
      } else {
        callback();
      }
    };
    return {
      test: [66, 67],
      current: "1",
      types: [
        {
          type: "1",
          label: "个人信息",
        },
        {
          type: "2",
          label: "账户安全",
        },
      ],
      attrs: [],
      userInfo: {
        avatar: "",
        nickname: "",
        mobile: "",
        sex: "",
        birthday: "",
        province_id: "",
        city_id: "",
        district_id: "",
        face_photo: "",
      },
      rules: {
        avatar: [{ required: true, message: "头像不能为空", trigger: "blur" }],
        nickname: [
          { required: true, message: "昵称不能为空", trigger: "blur" },
        ],
        sex: [{ required: false, message: "性别不能为空", trigger: "change" }],
        birthday: [
          { required: false, message: "出生日期不能为空", trigger: "change" },
        ],
        district_id: [
          { required: false, message: "所在城市不能为空", trigger: "change" },
        ],
      },
      showPasswordDialog: false,
      passwordForm: {
        mobile: "",
        password: "",
        sms_code: "",
      },
      passwordRules: {
        mobile: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
        ],
        password: [
          {
            required: true,
            validator: validateRePass,
            trigger: "blur",
          },
        ],
        sms_code: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
      countDown: 0,
      uploadUrl: buildConfig.BASE_URL + "/api/app/public/img",
      headers: { Authorization: "Bearer " + localStorage.studentToken },
      options: {
        disabledDate: function (date) {
          return date > new Date();
        },
      },
      currentUploadIndex: 0,
      showPhoneDialog: false,
      phoneForm: {
        old_sms_code: "", //老手机的验证码
        mobile: "", //新手机号
        sms_code: "", //新手机号的验证码
      },
      phoneCountDown: 0,
      newPhoneCountDown: 0,
      phoneRules: {
        mobile: [{ required: true, validator: validatePhone, trigger: "blur" }],
        old_sms_code: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
        sms_code: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
      changePhoneStep: 1,
      columns:['MPAcc','MLIS','MAud','MEM','MBA','MPA','MTA','EMBA']
    };
  },
  computed: {
    hideMobile() {
      return (
        this.userInfo.mobile.substring(0, 3) +
        "****" +
        this.userInfo.mobile.substring(7)
      );
    },
    schoolCount() {
      return this.$store.getters.schoolCount;
    },
  },
  async created() {
    this.initData();
  },
  methods: {
    async initData() {
      let data = await this.$http.get("/api/app/userInfo");
      this.userInfo = data
      this.userInfo.origin_school_name = data.origin_school_name;
      this.userInfo.avatar = data.avatar;
      this.userInfo.nickname = data.nickname;
      this.userInfo.mobile = data.mobile;
      this.userInfo.face_photo = data.face_photo;
      if (data.sex != 0 && data.sex != 1) {
        data.sex = 3;
      }
      this.userInfo.sex = data.sex.toString();
      this.userInfo.birthday =
        data.birthday == 0 || data.birthday == "NaN-aN-aN" ? "" : data.birthday;
      this.userInfo.province_id = data.province_id || "";
      this.userInfo.city_id = data.city_id || "";
      this.userInfo.district_id = data.district_id || "";
      // 筛选出用户未填写过的信息项，进行初始化赋值
      let attrs = await this.$http.get("/api/app/attribute/1");
      let attrsCopy = JSON.parse(JSON.stringify(attrs));
      for (let i = attrsCopy.length - 1; i >= 0; i--) {
        if (data.attr.find(t => t.attr_id == attrsCopy[i].id)) {
          attrsCopy.splice(i, 1);
        }
      }
      for (let value of attrsCopy) {
        let obj = {
          address: "",
          attr_id: value.id,
          attr_val: "",
          city_id: "",
          city_name: "",
          district_id: "",
          district_name: "",
          end_time: 0,
          province_id: "",
          province_name: "",
          start_time: 0,
          type: value.type,
        };
        data.attr.push(obj);
      }
      // 已填写过的信息项进行赋值
      this.setDeaultValue(data, attrs);
      this.attrs = attrs;
      this.passwordForm.mobile = data.mobile;
      this.$nextTick(() => {
        this.$refs["userForm"].clearValidate();
      });
      triggerLoaded(this);
    },
    setDeaultValue(data, attrs) {
      for (let i = 0; i < attrs.length; i++) {
        let trigger = "blur";
        for (let j = 0; j < data.attr.length; j++) {
          // 已填写的属性赋值
          if (attrs[i].id == data.attr[j].attr_id) {
            switch (attrs[i].type) {
              case 1:
                this.handleProfile(data.attr[j], i, 1);
                // if (data.attr[j].attr_val) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i,
                //     parseInt(data.attr[j].attr_val),
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i, "");
                // }
                trigger = "change";
                break;
              case 2:
                this.handleProfile(data.attr[j], i, 2);
                // if (data.attr[j].attr_val) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i,
                //     data.attr[j].attr_val.split(",").map(function (item) {
                //       return +item;
                //     }),
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i, []);
                // }
                trigger = "change";
                break;
              case 3:
                this.handleProfile(data.attr[j], i, 3);
                // if (data.attr[j].attr_val) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i,
                //     data.attr[j].attr_val + "",
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i, "");
                // }
                break;
              case 4:
                this.handleProfile(data.attr[j], i, 3);
                // if (data.attr[j].attr_val) {
                //   this.$set(this.userInfo, "attr" + i, data.attr[j].attr_val);
                // } else {
                //   this.$set(this.userInfo, "attr" + i, "");
                // }
                trigger = "change";
                break;
              case 5:
                this.handleProfile(data.attr[j], i, 4, "province_id");
                this.handleProfile(data.attr[j], i, 4, "city_id");
                // this.handleProfile(data.attr[j], i, 4, "district_id");
                // if (data.attr[j].province_id) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i + "province_id",
                //     data.attr[j].province_id,
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i + "province_id", "");
                // }
                // if (data.attr[j].city_id) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i + "city_id",
                //     data.attr[j].city_id,
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i + "city_id", "");
                // }
                // if (data.attr[j].city_id) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i + "city_id",
                //     data.attr[j].city_id,
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i + "city_id", "");
                // }
                if (data.attr[j].district_id) {
                  this.$set(
                    this.userInfo,
                    "attr" + i,
                    data.attr[j].district_id,
                  );
                } else {
                  this.$set(this.userInfo, "attr" + i + "city_id", "");
                }
                // if (data.attr[j].address) {
                //   this.$set(
                //     this.userInfo,
                //     "attr" + i + "address",
                //     data.attr[j].address,
                //   );
                // } else {
                //   this.$set(this.userInfo, "attr" + i + "address", "");
                // }
                this.handleProfile(data.attr[j], i, 4, "address");
                trigger = "change";
                break;
              case 6:
                if (data.attr[j].attr_val) {
                  this.$set(this.userInfo, "attr" + i, data.attr[j].attr_val);
                } else {
                  this.$set(this.userInfo, "attr" + i, "");
                }
                break;
              case 7:
                if (data.attr[j].attr_val) {
                  this.$set(
                    this.userInfo,
                    "attr" + i,
                    data.attr[j].attr_val * 1000,
                  );
                } else {
                  this.$set(this.userInfo, "attr" + i, "");
                }
                trigger = "change";
                break;
              case 8:
                if (data.attr[j].start_time) {
                  this.$set(this.userInfo, "attr" + i, [
                    data.attr[j].start_time * 1000,
                    data.attr[j].end_time * 1000,
                  ]);
                } else {
                  this.$set(this.userInfo, "attr" + i, "");
                }
                trigger = "change";
                break;
              case 9:
                this.handleProfile(data.attr[j], i, 3);
                // if (data.attr[j].attr_val) {
                //   this.$set(this.userInfo, "attr" + i, data.attr[j].attr_val);
                // } else {
                //   this.$set(this.userInfo, "attr" + i, "");
                // }
                break;
              default:
                if (data.attr[j].attr_val) {
                  this.$set(
                    this.userInfo,
                    "attr" + i,
                    JSON.parse(data.attr[j].attr_val),
                  );
                  let arr = [];
                  for (let value of JSON.parse(data.attr[j].attr_val)) {
                    arr.push({
                      url: value,
                    });
                  }
                  attrs[i].fileList = arr;
                } else {
                  this.$set(this.userInfo, "attr" + i, []);
                  attrs[i].fileList = [];
                }
            }
          }
        }
        let arr = [
          {
            required: attrs[i].is_required == 1,
            message: attrs[i].attr + "不能为空",
            trigger: trigger,
          },
        ];
        this.$set(this.rules, "attr" + i, arr);
      }
    },
    handleProfile(data, i, type, name) {
      if (type == 1) {
        this.$set(
          this.userInfo,
          "attr" + i,
          data.attr_val ? parseInt(data.attr_val) : "",
        );
      } else if (type == 2) {
        if (data.attr_val) {
          this.$set(
            this.userInfo,
            "attr" + i,
            data.attr_val.split(",").map(function (item) {
              return +item;
            }),
          );
        } else {
          this.$set(this.userInfo, "attr" + i, []);
        }
      } else if (type == 3) {
        this.$set(
          this.userInfo,
          "attr" + i,
          data.attr_val ? data.attr_val + "" : "",
        );
      } else if (type == 4) {
        this.$set(
          this.userInfo,
          "attr" + i + name,
          data[name] ? data[name] : "",
        );
      }
    },
    changeTab(item) {
      this.current = item.type;
    },
    areaChange(area) {
      this.userInfo.province_id = area.provinceId;
      this.userInfo.city_id = area.cityId;
      this.userInfo.district_id = area.districtId;
    },
    areaChangeMore(area) {
      this.userInfo["attr" + area.index + "province_id"] = area.provinceId;
      this.userInfo["attr" + area.index + "city_id"] = area.cityId;
      this.$set(this.userInfo, "attr" + area.index, area.districtId);
    },
    saveUser() {
      this.$refs["userForm"].validate(async valid => {
        if (!valid) {
          return;
        }
        let data = {};
        data.nickname = this.userInfo.nickname;
        data.avatar = this.userInfo.avatar;
        data.sex = this.userInfo.sex;
        data.face_photo = this.userInfo.face_photo;
        data.birthday = this.userInfo.birthday
          ? new Date(this.userInfo.birthday).format("yyyy-MM-dd")
          : "";
        data.province_id = this.userInfo.province_id;
        data.city_id = this.userInfo.city_id;
        data.district_id = this.userInfo.district_id;

        data.apply_major = this.userInfo.apply_major;
        data.apply_colleges = this.userInfo.apply_colleges;

        let attrVals = [];
        for (let i = 0; i < this.attrs.length; i++) {
          let val = this.userInfo["attr" + i];
          let obj = {};
          obj.attr_id = this.attrs[i].id;
          switch (this.attrs[i].type) {
            case 1:
              obj.attr_val_id = val;
              break;
            case 2:
              obj.attr_val_id = val.join(",");
              break;
            case 3:
              obj.attr_val_id = val;
              break;
            case 4:
              obj.attr_val_id = val;
              break;
            case 5:
              obj.province_id = this.userInfo["attr" + i + "province_id"];
              obj.city_id = this.userInfo["attr" + i + "city_id"];
              obj.district_id = this.userInfo["attr" + i];
              obj.address = this.userInfo["attr" + i + "address"];
              break;
            case 6:
              obj.attr_val_id = val;
              break;
            case 7:
              obj.attr_val_id = val / 1000 || "";
              break;
            case 8:
              obj.start_time = val[0] / 1000 || "";
              obj.end_time = val[1] / 1000 || "";
              break;
            case 9:
              obj.attr_val_id = val;
              break;
            default:
              obj.attr_val_id = JSON.stringify(val);
          }
          attrVals.push(obj);
        }
        data.user_attr = JSON.stringify(attrVals);
        await this.$http.put("/api/app/user", data);
        await this.$success("保存成功");
        this.$store.dispatch("get_user_info");
      });
    },
    async getSmsCode() {
      if (this.passwordForm.mobile == "") {
        await this.$info("请输入手机号");
        return;
      }
      await this.$services.CodeService.sendSmsCode(
        this.passwordForm.mobile,
        "getPassword",
      );
      this.countDown = 60;
      let timer = setInterval(() => {
        this.countDown--;
        if (this.countDown == 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    async submitChangePassword() {
      this.$refs["passwordForm"].validate(async valid => {
        if (!valid) {
          return;
        }
        await this.$http.post("/api/app/password", {
          mobile: this.userInfo.mobile,
          password: Encrypt(this.passwordForm.password),
          sms_code: this.passwordForm.sms_code,
        });
        this.showPasswordDialog = false;
        this.passwordForm.sms_code = "";
        this.passwordForm.password = "";
        await this.$success("密码修改成功，请重新登录");
        this.$store.commit("logout");
        this.$LoginModal.login({ type: "passwordLogin", store: this.$store });
      });
    },
    onBeforeUpload(file) {
      let ext = file.name.split(".").pop();
      if (ext != "jpg" && ext != "jpeg" && ext != "png") {
        this.$error("请上传jpg或者png图片");
        return false;
      }
    },
    async uploadSuccess(response) {
      if (response.code != 200) {
        await this.$error(response.msg);
      } else {
        this.userInfo.avatar = response.data.url;
      }
    },
    async uploadFaceSuccess(response) {
      if (response.code != 200) {
        await this.$error(response.msg);
      } else {
        this.userInfo.face_photo = response.data.url;
      }
    },
    currentClickIndex(index) {
      this.currentUploadIndex = index;
    },
    // 单图上传成功
    async uploadSuccessSingle(response) {
      if (response.code != 200) {
        await this.$error(response.msg);
      } else {
        this.userInfo["attr" + this.currentUploadIndex] = response.data.url;
      }
    },
    // 多图上传成功
    uploadSuccessMore(response, file, fileList) {
      if (response.code != 200) {
        this.$error(response.msg);
      } else {
        let fileBox = [];
        for (let value of fileList) {
          let path = value.response ? value.response.data.url : value.url;
          fileBox.push(path);
        }
        this.userInfo["attr" + this.currentUploadIndex] = fileBox;
      }
    },
    // 多图上传超出个数限制
    uploadExceed() {
      this.$warning("已达最大上传个数！");
    },
    // 移除图片
    handleRemove(file, fileList) {
      let fileBox = [];
      for (let value of fileList) {
        let path = value.response.data.url;
        fileBox.push(path);
      }
      // this.fileLength = fileBox.length;
      // fileBox = fileBox.join(',');
      this.userInfo["attr" + this.currentUploadIndex] = fileBox;
    },
    onFacePhotoBeforeUpload() {},
    /**
     * 更换手机号
     * step1.验证旧手机
     * step2.绑定新手机
     */
    cancelDialog() {
      this.$refs["phoneForm"].clearValidate();
      this.showPhoneDialog = false;
    },
    // 获取旧手机的验证码
    async getOldSmsCode() {
      await this.$http.post("/api/app/user/changeMobile/code").then(() => {
        this.showPhoneDialog = true;
        this.phoneCountDown = 60;
        let timer = setInterval(() => {
          this.phoneCountDown--;
          if (this.phoneCountDown == 0) {
            clearInterval(timer);
          }
        }, 1000);
      });
    },
    // 获取新手机号的验证码
    async getNewSmsCode() {
      this.$refs["phoneForm"].validateField("mobile", async validMessage => {
        if (validMessage != "") {
          return;
        }
        await this.$http
          .post("/api/app/user/changeMobile/newCode", {
            mobile: this.phoneForm.mobile,
          })
          .then(() => {
            this.newPhoneCountDown = 60;
            let timer = setInterval(() => {
              this.newPhoneCountDown--;
              if (this.newPhoneCountDown == 0) {
                clearInterval(timer);
              }
            }, 1000);
          });
      });
    },
    // 点击更换手机号按钮
    async changeMobile() {
      // this.getOldSmsCode();
      if (this.phoneCountDown <= 0) {
        this.getOldSmsCode();
      } else {
        this.showPhoneDialog = true;
      }
    },
    // 第一步提交
    async submitChangePhone() {
      this.$refs["phoneForm"].validateField(
        "old_sms_code",
        async validMessage => {
          if (validMessage != "") {
            return;
          }
          await this.$http.post("/api/app/user/changeMobile/verifyOld", {
            sms_code: this.phoneForm.old_sms_code,
          });
          this.phoneCountDown = 0;
          this.changePhoneStep = 2;
        },
      );
    },
    // 第二步提交
    async submitNewPhone() {
      this.$refs["phoneForm"].validate(async valid => {
        if (!valid) {
          return;
        }
        await this.$http.post("/api/app/user/changeMobile/verifyNew", {
          sms_code: this.phoneForm.sms_code,
          old_sms_code: this.phoneForm.old_sms_code,
          mobile: this.phoneForm.mobile,
        });
        this.$success("更换成功，返回至个人中心");
        this.cancelDialog();
        this.initData();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../css/member-profile.scss";
</style>
